import posthog from 'posthog-js';
import { getPostHogBrowserInitConfig } from '@instamenu/posthog/client';

if (process.env.NEXT_PUBLIC_POSTHOG_KEY) {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, getPostHogBrowserInitConfig());
}
